// helpers.js
export function downloadFileFromBase64(fileName, base64Data, mimeType = "application/pdf") {
    const link = document.createElement('a');
    link.href = "data:" + mimeType + ";base64," + base64Data;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function print(elementId) {
    const content = document.getElementById(elementId);
    if (content) {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Wydruk</title>');
        printWindow.document.write('<link rel="stylesheet" href="/css/print.css" />');
        printWindow.document.write('</head><body>');
        printWindow.document.write(content.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }
}

export function copyToClipboard(text) {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        return Promise.resolve();
    }
}

export function setTileRipple(x, y) {
    document.documentElement.style.setProperty('--ripple-x', x + 'px');
    document.documentElement.style.setProperty('--ripple-y', y + 'px');
}
